type PageDataType = {
  [key: number]: any;
};

export function StandardLayout(
  ctas?: object[],
  socialLinks?: object,
  logoUrl?: string
): PageDataType {
  const pageData = {
    1: {
      sectionType: 1,
      sectionDisplayName: 'Header',
      isVisible: true,
      sectionPosition: 'left',
      sectionBackgroundColor: '',
      sectionBackgroundImageUrl: '',
      childSections: [
        {
          sectionDisplayName: 'Logo',
          sectionType: 9,
          isVisible: true,
          sectionPosition: 'left',
          sectionBackgroundColor: '',
          sectionBackgroundImageUrl: '',
          logoUrl,
          logoWidth: '300px',
          logoHeight: '65px',
          childSections: [],
        },
        {
          sectionDisplayName: 'Text',
          sectionType: 5,
          isVisible: true,
          sectionPosition: 'right',
          sectionBackgroundColor: '',
          sectionBackgroundImageUrl: '',
          textContent: `{{firstname}} {{lastname}}  |  {{email}} {{phone1}}  |  {{phone2}} {{department}}`,
          textWidth: '295px',
          textHeight: '65px',
          childSections: [],
          textColor: '',
          isUserContactInfo: true,
        },
      ],
    },
    2: {
      sectionType: 2,
      sectionDisplayName: 'Video player',
      isVisible: true,
      sectionPosition: 'center',
      sectionBackgroundColor: '',
      sectionBackgroundImageUrl: '',
      isOverrideVideoSettings: false,
      videoUrl: '',
      videoPlayerProperties: {
        playerBackgroundColor: null,
        playerButtonPosition: null,
        playerIconsColor: null,
      },
      childSections: [],
    },
    3: {
      sectionType: 3,
      sectionDisplayName: 'CTAs',
      isVisible: true,
      elementContainerPosition: 'center',
      sectionPosition: 'center',
      sectionBackgroundColor: '',
      sectionBackgroundImageUrl: '',
      childSections: [],
      links: ctas || [],
      elementProperties: {},
      isVertical: false,
    },
    4: {
      sectionType: 4,
      sectionDisplayName: 'Social Links',
      isVisible: true,
      sectionPosition: 'center',
      sectionBackgroundColor: '',
      sectionBackgroundImageUrl: '',
      socialLinks: socialLinks || {},
      childSections: [],
    },
  };

  return pageData;

  // 1- Header, 2- VideoPlayer 3- CTA, 4-SocialLinks, 5-Text 6- Image, 7-Video, 8- Links - 9 Logo

  //Section Types 1-Header 2- Video Player 3- cta 4- social-links 5- text -6 video 7-image 8-links
  //SECTION TYPES  1- Header 2-Text 3-Video-PLayer 4-link -5photo (6-socialLinks) buttons
  // Element Types 1-
}

// export default StandardLayout;

// textContent:
//             userInfo ||
//             `Your name  |  name@email.com
//           111-222-333  |  222-333-444
//           Your Department`,
